/* Enhanced Dashboard Animations */

@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.9;
  }
  100% {
    opacity: 0.6;
  }
}

@keyframes glow {
  0% {
    filter: drop-shadow(0 0 2px rgba(30, 64, 175, 0.2));
  }
  50% {
    filter: drop-shadow(0 0 5px rgba(30, 64, 175, 0.4));
  }
  100% {
    filter: drop-shadow(0 0 2px rgba(30, 64, 175, 0.2));
  }
}

@keyframes progressPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(30, 64, 175, 0.3);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(30, 64, 175, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(30, 64, 175, 0);
  }
}

@keyframes subtleHighlight {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.85;
  }
  100% {
    opacity: 1;
  }
}

.radar-pulse {
  animation: pulse 3s infinite ease-in-out;
}

.subtle-highlight {
  animation: subtleHighlight 4s infinite ease-in-out;
}

.radar-container {
  position: relative;
}

.radar-glow {
  animation: glow 3s infinite ease-in-out;
}

.progress-pulse {
  animation: progressPulse 2s infinite cubic-bezier(0.66, 0, 0, 1);
}

.highlight-point {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 0 10px 2px rgba(154, 132, 183, 0.8);
  animation: pulse 2s infinite ease-in-out;
}

.quick-win-card {
  transition: all 0.3s ease;
  border-left: 4px solid #8675A9;
}

.quick-win-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.maturity-marker {
  position: relative;
  z-index: 10;
}

.maturity-marker::after {
  content: '';
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  border-radius: 50%;
  background: rgba(154, 132, 183, 0.3);
  z-index: -1;
  animation: pulse 2s infinite;
}

/* Card flip animation */
.card-container {
  perspective: 1000px;
  cursor: pointer;
}

.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.card-flipped .card-inner {
  transform: rotateY(180deg);
}

.card-front, .card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 0.5rem;
}

.card-back {
  transform: rotateY(180deg);
}

.clickable-card {
  cursor: pointer;
  transition: all 0.2s ease;
}

.clickable-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}
